import { Close, Edit } from "assets/svg";
import { FormattedMessage } from "react-intl";
import { useEventStore } from "store";
import { useEffect, useState } from "react";

type TImagePreviewProps = {
  selectedImage: File | null;
  originalImage: File | null;
  setSelectedImage: (file: File | null) => void;
  setCroppedImage: (file: File | null) => void;
  setTempImageFile: (file: File | null) => void;
  setShowImageResizer: (show: boolean) => void;
};

export default function ImagePreview({
  selectedImage,
  originalImage,
  setSelectedImage,
  setCroppedImage,
  setTempImageFile,
  setShowImageResizer,
}: TImagePreviewProps) {
  const { theme } = useEventStore();

  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedImage(file);
      setCroppedImage(null);
      setTempImageFile(file);
      setShowImageResizer(true);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setCroppedImage(null);
    if (imageUrl) {
      URL.revokeObjectURL(imageUrl);
      setImageUrl(null);
    }
  };

  const handleEditImage = () => {
    if (originalImage) {
      setTempImageFile(originalImage);
      setShowImageResizer(true);
    }
  };

  useEffect(() => {
    if (selectedImage) {
      const url = URL.createObjectURL(selectedImage);
      setImageUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    } else {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
        setImageUrl(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedImage]);

  return (
    <div
      className={`w-fit h-full relative flex items-center justify-center mx-auto`}
    >
      {!selectedImage ? (
        <label
          className={`${theme.card} min-h-40 min-w-80 card shadow-none border text-theme-black border-gray-200 w-full h-full flex flex-col gap-2 items-center justify-center cursor-pointer`}
        >
          <Edit width={48} height={48} outline="#414141" color="#fff" />
          <div className="text-theme-black font-century-gothic">
            <FormattedMessage
              id="feed.newPost.selectImage"
              defaultMessage="Selecionar imagem"
            />
          </div>
          <input
            type="file"
            accept="image/jpeg, image/png, image/jpg"
            className="hidden"
            onChange={handleImageChange}
          />
        </label>
      ) : (
        <>
          <img
            src={imageUrl || ""}
            alt="Preview post"
            className={`${theme.card} card object-cover w-full h-full max-h-[500px] shadow-lg shadow-gray-400`}
          />
          <div className="absolute top-5 right-5 flex gap-2">
            <div
              className="cursor-pointer bg-white rounded-full p-1 shadow-md"
              onClick={handleEditImage}
              title="Editar imagem"
            >
              <Edit width={20} height={20} outline="#414141" color="#fff" />
            </div>
            <div
              className="cursor-pointer bg-white rounded-full p-1 shadow-md"
              onClick={handleRemoveImage}
              title="Remover imagem"
            >
              <Close width={20} height={20} color="none" outline="#414141" />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
